import { useTheme } from 'styled-components';

import Price from '@components/ui/price';
import { getCurrencySymbol } from '@utils/utils';
import OriginalPrice from '@components/ui/price/OriginalPrice';
import { HotelRoomStatusType } from '@api/v3';
import { PaletteColor } from '@utils/types';

import { getDateColor } from './components/AvailableRoomDates/helpers';
import { Wrapper, Container, Date, Day } from './PriceCardStyle';

export interface PriceCardProps {
  date?: string;
  day?: string;
  discounted?: number;
  price: number;
  currency?: string;
  status?: HotelRoomStatusType;
}

const PriceCard = ({
  date,
  day,
  discounted,
  price,
  currency,
  status,
}: PriceCardProps) => {
  const { palette } = useTheme();

  return (
    <Wrapper
      borderColor={(getDateColor(palette, status) as PaletteColor) ?? 'D30'}
    >
      <Container>
        <Date>{date}</Date>
        <Day>{day}</Day>
        <Price
          fontSize={24}
          price={price}
          sellingPrice={discounted}
          originalPriceCurrency={getCurrencySymbol(currency)}
        >
          {price !== discounted ? (
            <OriginalPrice
              price={price}
              currency={getCurrencySymbol(currency)}
              noLine={false}
            />
          ) : null}
        </Price>
      </Container>
    </Wrapper>
  );
};

export default PriceCard;
